import { logger } from '@getaccept/lib-shared/src/logger';
import { defineStore } from 'pinia';
import { useStorage } from '@vueuse/core';
import { ref } from 'vue';
import type { TokenResponse } from '@getaccept/lib-shared/src/types/token-response';
import { SessionStorageKey } from '@getaccept/lib-shared/src/session/type/enums/session-storage-keys';
import { pusherClientInternal } from '../../pusher';
import { AuthService } from '../../../api/auth/services/auth.service';

export const useAuthStore = defineStore('auth', () => {
  const token = useStorage<string>(SessionStorageKey.Token, null);
  const tokenIsError = ref(false);

  const setToken = (accessToken: string) => {
    token.value = accessToken;
    pusherClientInternal.updateToken(accessToken);
  };

  const fetchToken = async () => {
    const milliseconds = 1000;
    const expiresIn = 1200;
    tokenIsError.value = false;
    try {
      const { access_token = '' }: TokenResponse = await AuthService.getToken();
      setTimeout(() => {
        fetchToken();
      }, expiresIn * milliseconds);
      setToken(access_token);
    } catch {
      logger.error('Could not fetch token');
      tokenIsError.value = true;
    }
  };

  return {
    token,
    tokenIsError,
    setToken,
    fetchToken,
  };
});
